import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MobileShell, C, MobileHeader } from './MobileShell';
import mapi from './api';
import { Video } from 'lucide-react';
import { formatClocks } from '@/lib/utils';

export default function MobileOnlineJoin() {
  const { courseId } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    mapi.get(`/online-lessons/courses/${courseId}/join`)
      .then((r) => setInfo(r.data))
      .catch((e) => setError(e.response?.data?.detail || 'Online-Raum konnte nicht geladen werden.'));
  }, [courseId]);

  return (
    <MobileShell>
      <MobileHeader title="Onlineunterricht" backTo="/m" />
      <div className="flex-1 px-4 pb-8 pt-4 space-y-3" data-testid="mobile-online-join-page">
        {error && (
          <div className="rounded-xl px-3 py-2 text-xs" data-testid="mobile-online-join-error"
               style={{ background: '#7f1d1d', color: '#fca5a5' }}>{error}</div>
        )}
        {!info && !error && <p className="text-sm" style={{ color: C.dim }}>Laden...</p>}
        {info && (
          <div className="rounded-2xl p-4 space-y-3" style={{ background: C.card, border: `1px solid ${C.border}` }}>
            <div className="flex items-center gap-2">
              <Video className="w-5 h-5" style={{ color: '#34d399' }} />
              <div className="text-sm font-semibold" style={{ color: C.text }}>{formatClocks(info.course_name) || info.course_name}</div>
            </div>
            <p className="text-xs" style={{ color: C.dim }}>
              Der Unterricht findet online per Video statt. Tippe auf „Jetzt beitreten" —
              das Meeting öffnet sich im Browser oder in der Jitsi-App.
            </p>
            <a href={info.url} target="_blank" rel="noopener noreferrer"
               data-testid="mobile-online-join-now-btn"
               className="w-full flex items-center justify-center gap-2 rounded-xl px-3 py-3 text-sm font-semibold"
               style={{ background: '#059669', color: '#ffffff' }}>
              <Video className="w-4 h-4" /> Jetzt beitreten
            </a>
          </div>
        )}
      </div>
    </MobileShell>
  );
}
